import React from "react";
import { useParams } from "react-router-dom";
import { getMarketTrendsDetails } from "../../services/scenarios";
import { queryKeys } from "../../constants";
import { useQuery } from "@tanstack/react-query";
import { Typography, Image } from "antd";
import classes from "./RealTimeTrendDetails.module.scss";
import dayjs from "dayjs";
const { Title, Text } = Typography;

const RealTimeTrendDetails = () => {
  const { id } = useParams();

  const getTrendDetailsQuery = useQuery({
    queryKey: [queryKeys.getMarketTrendsDetails, { articleId: id }],
    queryFn: () => getMarketTrendsDetails({ articleId: id }),
  });

  const { results } = getTrendDetailsQuery?.data?.data || {};

  return (
    <div>
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
          New Details
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Real-time trend tracking involves continuously monitoring various data
          sources, such as social media, news outlets, and industry reports.
        </Text>
      </div>
      <div>
        <Image src={results?.[0]?.image ?? ""} />
        <div className={classes.infoContainer}>
          <Title
            level={5}
            style={{ marginTop: 0, marginBottom: 0, minWidth: "100px" }}
          >
            Headline :
          </Title>
          <Text>{results?.[0]?.headline}</Text>
        </div>
        <div className={classes.infoContainer}>
          <Title
            level={5}
            style={{ marginTop: 0, marginBottom: 0, minWidth: "100px" }}
          >
            Summary :
          </Title>
          <Text>{results?.[0]?.summary}</Text>
        </div>
        <div className={classes.infoContainer}>
          <Title level={5} style={{ marginTop: 0, marginBottom: 0, minWidth: "100px" }}>
            Category :
          </Title>
          <Text>{results?.[0]?.category}</Text>
        </div>
        <div className={classes.infoContainer}>
          <Title level={5} style={{ marginTop: 0, marginBottom: 0, minWidth: "100px" }}>
            News Type :
          </Title>
          <Text>{results?.[0]?.news_type}</Text>
        </div>
        <div className={classes.infoContainer}>
          <Title level={5} style={{ marginTop: 0, marginBottom: 0, minWidth: "100px" }}>
            Source :
          </Title>
          <Text>{results?.[0]?.source}</Text>
        </div>
        <div className={classes.infoContainer}>
          <Title level={5} style={{ marginTop: 0, marginBottom: 0, minWidth: "100px" }}>
            Created At :
          </Title>
          <Text>
            {results?.[0]?.created_at
              ? dayjs(results?.[0]?.created_at).format("DD/MM/YYYY hh:mm:ss")
              : ""}
          </Text>
        </div>
        <div className={classes.infoContainer}>
          <Title level={5} style={{ marginTop: 0, marginBottom: 0, minWidth: "100px" }}>
            URL
          </Title>
          <a href={results?.[0]?.url ?? ""} target="_blank" rel="noreferrer">
            {results?.[0]?.url ?? ""}
          </a>
        </div>
      </div>
    </div>
  );
};

export default RealTimeTrendDetails;
